
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 23C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11zM7.715 9.161c.757 0 1.371-.56 1.371-1.251 0-.692-.614-1.253-1.371-1.253-.758 0-1.372.56-1.372 1.253 0 .691.614 1.251 1.372 1.251zm-1.058 8.05h2.46v-7.097h-2.46v7.096zm5.914-3.947c0-.814.385-1.61 1.305-1.61.92 0 1.147.796 1.147 1.59v3.876h2.45v-4.034c0-2.803-1.657-3.286-2.676-3.286-1.018 0-1.58.344-2.226 1.179v-.955h-2.457v7.096h2.457v-3.856z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    